import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/professional-area';

export class ProfessionalAreaService extends RestServiceConnection {
    list = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-for-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    get = async (professionalAreaId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { professionalAreaId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    create = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: entity,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    edit = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: { ...entity, professionalAreaId: entity.id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    delete = async (professionalAreaId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { professionalAreaId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
}

